import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import { useCallback, useLayoutEffect, useRef } from "react";
import { getOptimizedImageForType } from "../../utils/cms.utils";
import OptimizedImage from "../common/OptimizedImage";
import ContentTag from "../../utils/tag";
import { useNavigate } from "react-router-dom";
import { useInputMode } from "../../utils/hooks/useInputMode";
import {
  focusHomeMenu,
  resetRowTransformAfterBlur,
  resetRowTransformIfUnfocused,
  syncFocusedRowTransform,
} from "./focusHelpers";

const ContentItem = ({ item = {}, onFocus, onBlur, isFirst, focusKey }) => {
  const navigate = useNavigate();
  const { focused, ref, focusSelf } = useFocusable({
    focusKey,
    onFocus,
    onBlur,
    onEnterPress: () => {
      navigate(`/movie/${item.slug}`);
    },
    onArrowPress: (direction) => {
      if (direction === "right" && isFirst) {
        return focusHomeMenu();
      }
      return true;
    },
  });

  const { setMouseFocus } = useInputMode();
  const handleMouseEnter = useCallback(() => {
    setMouseFocus(true);
    focusSelf();
  }, [focusSelf, setMouseFocus]);

  const { contentPhotos, title, year } = item || {};

  // Get optimized image with LQIP and WebP support
  const imageData = getOptimizedImageForType("horizontalCover", contentPhotos, "TV", { width: 440, quality: 90, format: 'jpeg' });

  return (
    <div
      ref={ref}
      className={"legacy-online-card" + (focused ? " is-focused" : "")}
      onClick={() => navigate(`/movie/${item.slug}`)}
      onMouseEnter={handleMouseEnter}
    >
      <OptimizedImage
        src={imageData.src}
        className="absolute inset-0 w-full h-full"
        style={{
          objectFit: 'cover',
          borderRadius: "20px",
        }}
      />
      <ContentTag label={"آنلاین باخیش"} relative />
      <div className="legacy-online-focus-border" />
      <div className="legacy-online-overlay">
        <span className="legacy-online-title">{title}</span>
        <span className="legacy-online-year">{year}</span>
      </div>
    </div>
  );
};

export const OnlineBakhish = ({ movies, onFocus, rowTitle, id, index }) => {
  const itemFocusKeyPrefix = "onlinebakhish_item_" + id + "_";
  const { ref, focusKey } = useFocusable({
    isFocusBoundary: true,
    focusBoundaryDirections: ["left"],
    focusKey: "onlinebakhish_" + id,
    focusable: false,
    trackChildren: true,
    autoRestoreFocus: true,
    preferredChildFocusKey: itemFocusKeyPrefix + "0",
  });

  const scrollingRef = useRef(null);
  const innerRef = useRef(null);
  useLayoutEffect(() => {
    var delays = [0, 80, 220, 600, 1400, 2600];
    resetRowTransformIfUnfocused(innerRef);
    var timers = delays.map(function (delay) {
      return setTimeout(function () {
        resetRowTransformIfUnfocused(innerRef);
      }, delay);
    });

    return function () {
      timers.forEach(function (timer) {
        clearTimeout(timer);
      });
    };
  }, [movies.length]);
  const { isMouseFocus } = useInputMode();
  const onAssetFocus = useCallback(
    (props) => {
      if (typeof onFocus === "function") onFocus(props);
      if (isMouseFocus) return;
      syncFocusedRowTransform({
        innerRef,
        scrollerRef: scrollingRef,
        leftPadding: 300,
      });
    },
    [scrollingRef, isMouseFocus, onFocus]
  );
  const onAssetBlur = useCallback(
    () => {
      resetRowTransformAfterBlur(innerRef);
    },
    []
  );

  if (movies.length < 1) return null;

  return (
    <FocusContext.Provider value={focusKey}>
      <div className="legacy-online-row" ref={ref} tabIndex={index}>
        <h2 className="legacy-online-row-title">{rowTitle}</h2>
        <div className="legacy-online-scroller" ref={scrollingRef}>
          <div className="legacy-online-content" ref={innerRef}>
            {movies?.map((item, idx) => {
              return (
                <ContentItem
                  item={item?.content}
                  key={"online-bakhish-" + item?.content?.slug}
                  onFocus={onAssetFocus}
                  onBlur={onAssetBlur}
                  isFirst={idx === 0}
                  focusKey={itemFocusKeyPrefix + idx}
                />
              );
            })}
          </div>
        </div>
      </div>
    </FocusContext.Provider>
  );
};
